$(function($) {

    $(".search-toggle").on('click', function(e) {
      $(".header-wrap").toggleClass('search-active');
      e.preventDefault();
    });
    $("body").on("click",".nav-trigger",function() {
      $(".header-wrap").toggleClass("menu-open");
      // $(this).toggleClass("m-menu-btn-ext");
    });
    $(".close-icon").click(function() {
      $(".header-wrap").removeClass("menu-open");
    });
    $('.mega-dropdown > a span').on("click", function(e) {
      if($(this).hasClass('ion-ios-arrow-up')) {
        removec();
      }else{
        removec();
        $(this).addClass("ion-ios-arrow-up");
        $(this).parent().next('.mega-menu-dropdown').slideDown(800);
      }
      e.stopPropagation();
      e.preventDefault();
    });
  
    function removec(){
      $(".mega-dropdown > a span").each(function () {
        $(this).removeClass("ion-ios-arrow-up");
        $(this).parent().next('.mega-menu-dropdown').slideUp(800);
      });
    }
    $('.second-lel > a > span').on("click", function(e) {
      $(this).toggleClass("ion-chevron-down");
      $(this).parent().next('.second-level-drop').slideToggle(800);
      e.stopPropagation();
      e.preventDefault();
    });
    $('.third-level-menu > .third-lel > span').on("click", function(e) {
      $(this).toggleClass("ion-chevron-down");
      $(this).parent().next('.third-level-drop').slideToggle(800);
      e.stopPropagation();
      e.preventDefault();
    });
    //  }
  
    $(".mega-menu-dropdown").hover(function() {
      $(this).prev('a').after().css("opacity", "1");
      // console.log($(this).prev('a').after());
    });
    $('.home-hero-slider').slick({
      dots: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 1,
      adaptiveHeight: true,
      autoplay: true,
      fade: true,
      speed: 900,
      cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      touchThreshold: 100
    });
  
    $('.footer-widget span.f-title').on("click", function(e) {
      $(this).parents('.footer-widget').find('.slides-toggle').slideToggle(600);
      $(this).toggleClass("open");
      e.stopPropagation();
      e.preventDefault();
    });
  
    $(window).load(function() {
      equalheight('.footer-site-info .details-info-title');
      equalheight('.footer-site-info .img-info');
   //   equalheight('.home-collection-list-wrapper .single-sub-coll-title-link-wrap');
     // equalheight('.home-collection-list-wrapper .single-sub-coll-title-link-wrap a');
      equalheight('.home-all-things-section .equalheightblock1');
      //equalheight('.gridview-item .title-flex a.pro-title');
      equalheight('.products-text dl.price');
      equalheight('.section_login .hight_box');
      equalheight('.our_industry_img h4');
      $('.refine_search_rsp').css("display","block");
      setTimeout(function(){
      //  equalheight('.gridview-item .title-flex a.pro-title');
        $('.remove-hide').css("display","block");
     //   equalheight('.ruk_rating_snippet_container');
      //  equalheight('.home-collection-list-wrapper .single-sub-coll-title-link-wrap');
      },3000);
      //       if ($(window).width() <= 425) {
      //       	setTimeout(function(){equalheight('.listview-item .title-flex a.pro-title');},3000);
      //       }
      $('.remove-hide').css("display","block");
    });
  
    let spanInterval = setInterval(function(){
      if($('.gridview-item .title-flex a.pro-title').length > 0){    
          clearInterval(spanInterval);
          equalheight('.gridview-item .title-flex a.pro-title');
          equalheight('.ruk_rating_snippet_container')
         
      }
    }, 500);
  
    $(window).resize(function() {
      equalheight('.footer-site-info .details-info-title');
      equalheight('.footer-site-info .img-info');
    //  equalheight('.home-collection-list-wrapper .single-sub-coll-title-link-wrap');
   //   equalheight('.home-collection-list-wrapper .single-sub-coll-title-link-wrap a');
      equalheight('.home-all-things-section .equalheightblock1');
      equalheight('.gridview-item a.pro-title');
      // equalheight('.products-text dl.price');
      equalheight('.our_industry_img h4');
      equalheight('.gridview-item .title-flex a.pro-title');
      if($(window).width() <= 425) {
        equalheight('.listview-item .title-flex a.pro-title');
      }
    });
    /*---------------- HOME SHOWS SLIDER START ------------------*/
    $('.custom-brand-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      infinite: true,
      dots: false,
      arrows: false,
      responsive: [{
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true
        }
      },
                   {
                     breakpoint: 569,
                     settings: {
                       slidesToShow: 3,
                       slidesToScroll: 1,
                       dots: true
                     }
                   }
                  ]
    });
  
  
  
  
  
    loadGallery(true, 'a.thumbnail');
  
    //This function disables buttons when needed
    function disableButtons(counter_max, counter_current) {
      $('#show-previous-image, #show-next-image').show();
      if (counter_max == counter_current) {
        $('#show-next-image').hide();
      } else if (counter_current == 1) {
        $('#show-previous-image').hide();
      }
    }
  
    /**
       *
       * @param setIDs        Sets IDs when DOM is loaded. If using a PHP counter, set to false.
       * @param setClickAttr  Sets the attribute for the click handler.
       */
  
    function loadGallery(setIDs, setClickAttr) {
      var current_image,
          selector,
          counter = 0;
  
      $('#show-next-image, #show-previous-image').click(function() {
        if ($(this).attr('id') == 'show-previous-image') {
          current_image--;
        } else {
          current_image++;
        }
  
        selector = $('[data-image-id="' + current_image + '"]');
        updateGallery(selector);
      });
  
      function updateGallery(selector) {
        var $sel = selector;
        current_image = $sel.data('image-id');
        $('#image-gallery-caption').text($sel.data('caption'));
        $('#image-gallery-title').text($sel.data('title'));
        $('.modal-body').attr('style', 'background:url(' + $sel.data('image') + ');');
        disableButtons(counter, $sel.data('image-id'));
      }
  
      if (setIDs == true) {
        $('[data-image-id]').each(function() {
          counter++;
          $(this).attr('data-image-id', counter);
        });
      }
      $(setClickAttr).on('click', function() {
        updateGallery($(this));
      });
    }
    $('.popup-video').magnificPopup({
      disableOn: 200,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,
      gallery: {
        enabled: true,
        navigateByImgClick: true,
        preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
      }
    });
    $('.sidebar-content > .title').on("click", function(e) {
      $(this).next('.inner-content').slideToggle(600);
      $(this).toggleClass('open');
      e.stopPropagation();
      e.preventDefault();
    });
    $(".filter-btn").click(function() {
      $(".sidebar-col").addClass("sidebar-open");
    });
    $(".close-btn").click(function() {
      $(".sidebar-col").removeClass("sidebar-open");
    });
  
    /*---------------- Shop Slider ------------------*/
  
  
    $('.prod-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      infinite: false,
      fade: false,
    });
    $('.shop-slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: false,
      focusOnSelect: false,
      vertical: true,
      verticalSwiping: false,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            vertical: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            vertical: false
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            vertical: false
          }
        }
  
      ]
    });
    // Custom thumbnail click handler
    $('.shop-slider-nav .slick-slide').on('click', function(e){
      e.preventDefault();
      $('.shop-slider-nav .slick-slide').removeClass("slick-current-active");
      var slideIndex = $(this).data('slick-index');
      
      $('.prod-slider').slick('slickGoTo', slideIndex);
      $(this).addClass("slick-current-active");
    });
  
   $('.related-products-slider').slick({
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 320,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 425,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }
    ]
});
   $('.related-products-slider-cart-tpl').slick({
    dots: false,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    responsive: [
        {
            breakpoint: 320,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 425,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }
    ]
});

  $('#api-product-related-products-section-cart-drawer').slick({
    dots: false,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 2,
    
});
    $('.btn.plus').click(function(e) {
      e.preventDefault();
      fieldName = $(this).attr('field');
      var currentVal = parseInt($('input[name=' + fieldName + ']').val());
      if (!isNaN(currentVal)) {
        $('input[name=' + fieldName + ']').val(currentVal + 1);
      } else {
        $('input[name=' + fieldName + ']').val(1);
      }
    });
    $(".btn.minus").click(function(e) {
      e.preventDefault();
      fieldName = $(this).attr('field');
      var currentVal = parseInt($('input[name=' + fieldName + ']').val());
      if (!isNaN(currentVal) && currentVal > 1) {
        $('input[name=' + fieldName + ']').val(currentVal - 1);
      } else {
        $('input[name=' + fieldName + ']').val(1);
      }
    });
    $('.expertquestion').on("click", function() {
      $('#reamaze-widget').trigger('click');
    });
    $('.live-chat-now').on("click", function() {
      $('#reamaze-widget').trigger('click');
    });
  
  
    $('.car-symbol').magnificPopup({
      type: 'inline',
      preloader: false,
      focus: '#username',
      modal: true,
      fixedContentPos: false,
      removalDelay: 300,
      mainClass: 'my-mfp-slide-bottom',
      callbacks: {
        open: function() {
          jQuery('body').addClass('magnificpopupnoscroll');
        },
        close: function() {
          jQuery('body').removeClass('magnificpopupnoscroll');
        }
      }
    });
  
    $('.car-symbol').on("click", function() {
      $('body').css('overflow', 'hidden');
  
    });
    $('.mfp-close').on("click", function() {
      $('body').css('overflow', 'auto');
  
    });
  
    if ($(window).width() <= 1024) {
      $popHeight = $('.product-list .collection-image-block').outerHeight();
      $('.car-symbol').on("click", function() {
       
        $('.product-list .collection-image-block').css("min-height",$popHeight);
      });
      $('.mfp-close').on("click", function() {
     
        $('.product-list .collection-image-block').css("min-height",$popHeight);
      });
    }
  
       $(document).on('click', '.aside_slct_wrap', function(e) {
      const $currentBox = $(this);
      
      // Check if the clicked box is already active
      if ($currentBox.hasClass('active-ul')) {
        // If active, remove the class and close it
        $currentBox.removeClass('active-ul');
        $currentBox.find('.aside_slct_opts').slideUp();
      } else {
        // Otherwise, remove the class and close all other boxes
        $('.aside_slct_wrap').removeClass('active-ul');
        $('.aside_slct_opts').slideUp();
    
        // Add the class and open the clicked box
        $currentBox.addClass('active-ul');
        $currentBox.find('.aside_slct_opts').slideDown();
      }
    });
    $(window).resize(function() {
  
      if ($(window).width() <= 1024 && $('#custom-brand').length > 0) {
        $('.template-index #toggle-search').removeClass("fixed-ymm");
        var s = document.getElementById("custom-brand");
  
        var pos = s.offsetTop;
  
        $(window).scroll(function() {
  
          var windowpos = $(window).scrollTop();
          if (windowpos >= pos) {
            $('.template-index #toggle-search').removeClass("fixed-ymm");
            $('.template-index .toggleicons').removeClass("cardis");
  
          } else {
            $('.template-index #toggle-search').removeClass("fixed-ymm");
            $('.template-index .toggleicons').addClass("cardis");
  
          }
        });
      }
  
    });
  
    $(window).resize(function() {
      if ($(window).width() >= 1024 && $('#custom-brand').length > 0) {
        var s = document.getElementById("custom-brand");
        var pos = s.offsetTop;
        $(window).scroll(function() {
          var windowpos = $(window).scrollTop();
          if (windowpos >= pos) {
            $('.template-index #toggle-search').addClass("fixed-ymm");
            $('.template-index .toggleicons').removeClass("cardis");
          } else {
            $('.template-index #toggle-search').removeClass("fixed-ymm");
            $('.template-index .toggleicons').addClass("cardis");
          }
        });
      }
    });
    $(window).load(function() {
      if ($(window).width() >= 1024 && $('#custom-brand').length > 0) {
        var s = document.getElementById("custom-brand");
        var pos = s.offsetTop;
        $(window).scroll(function() {
          var windowpos = $(window).scrollTop();
          if (windowpos >= pos) {
            $('.template-index #toggle-search').addClass("fixed-ymm");
            $('.template-index .toggleicons').removeClass("cardis");
          } else {
            $('.template-index #toggle-search').removeClass("fixed-ymm");
            $('.template-index .toggleicons').addClass("cardis");
          }
        });
      }
  
  
  
    });
    $('#filter-open-btn1').on('click', function() {
      $('.sidebar-col').css("right", "0px");
    });
    $('.close-products-faceted-search-btn').on('click', function() {
      $('.sidebar-col').css("right", "-100%");
    });
    document.addEventListener("click", function(evt){
      let targetElement = evt.target; // clicked element
  
      const ddsv_year = document.getElementById("engineSelector-year-placeholder");
      const ddsv_make = document.getElementById("engineSelector-make-placeholder");
      const ddsv_model = document.getElementById("engineSelector-model-placeholder");
      do {
        if (targetElement == ddsv_year) {
          return;
        } else if (targetElement == ddsv_make) {
          return;
        } else if (targetElement == ddsv_model) {
          return;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);
      // This is a click outside.
      $("#engineSelector-year-placeholder").removeClass('active-ul');
      $("#engineSelector-year-placeholder ul").slideUp();
  
      $("#engineSelector-make-placeholder").removeClass('active-ul');
      $("#engineSelector-make-placeholder ul").slideUp();
  
      $("#engineSelector-model-placeholder").removeClass('active-ul');
      $("#engineSelector-model-placeholder ul").slideUp();
  
      if($('.aside_slct_wrap').hasClass('active-ul')){
  
        $('body').addClass("stop-scrolling");
      }else{
        $('body').removeClass("stop-scrolling");
      }
  
    });
    $(window).scroll(function() {
      $('.select-vehicle-col .aside_slct_wrap').removeClass('active-ul');
      $('.select-vehicle-col ul').slideUp();
    });
  
    $(window).resize(function() {
      if ($(window).width() <= 1024) {
        var s = document.getElementById("breadcrumbid");
        if(s.length){
          $('.otherpageymm #toggle-search').removeClass("fixed-ymm");
          var pos = s.offsetTop;
          $(window).scroll(function() {
            $('.otherpageymm  #toggle-search').removeClass("fixed-ymm");
            var windowpos = $(window).scrollTop();
            if (windowpos >= pos) {
              $('.otherpageymm  #toggle-search').removeClass("fixed-ymm");
              $('.otherpageymm  .toggleicons').removeClass("cardis");
  
            } else {
              $('.otherpageymm  #toggle-search').removeClass("fixed-ymm");
              $('.otherpageymm  .toggleicons').addClass("cardis");
            }
          });
        }
      }
    });        
  
    $(window).load(function() {
      if ($(window).width() <= 1024) {
        var s = document.getElementById("breadcrumbid");
        if(s.length){
          $('.otherpageymm #toggle-search').removeClass("fixed-ymm");
          //  var s = document.getElementById("breadcrumbid");
          var pos = s.offsetTop;
          $(window).scroll(function() {
            $('.otherpageymm  #toggle-search').removeClass("fixed-ymm");
            var windowpos = $(window).scrollTop();
            if (windowpos >= pos) {
              $('.otherpageymm  #toggle-search').removeClass("fixed-ymm");
              $('.otherpageymm  .toggleicons').removeClass("cardis");
  
            } else {
              $('.otherpageymm  #toggle-search').removeClass("fixed-ymm");
              $('.otherpageymm  .toggleicons').addClass("cardis");
            }
          });
        }
      }
      setTimeout(function(){
        if($('body .topbadge').html() == ''){
          $('body .topbadge').css("display","none");
          // console.log('checkkk');
        }else{
          //  console.log('uncheckkk');
        }
      },3000);
      var getwishurl = window.location.href;
      var parts = getwishurl.split("/");
      var last_part = parts[parts.length-1];
      if(last_part == 'wishlist'){
        $('.breadcrumb').html('<li><a href="/"> Home </a></li><li id="page_breadcrumb">Wishlist</li>');     
      }
    }); 
  
    // $(window).scroll(function() {
    //   if ($(window).scrollTop() >= 160) {
    //     $('body .header-wrap').addClass('fixed-header1');
    //     $('body').addClass('sticy-sidebar');
    //     $('.otherpageymm #toggle-search').addClass('fixed-ymm');
    //   } else {
    //     $('body .header-wrap').removeClass('fixed-header1');
    //     $('.otherpageymm #toggle-search').removeClass('fixed-ymm');
    //     $('body').removeClass('sticy-sidebar');
    //   }
    // });
  
    $(document).on('click touchstart', function(e) {
      if (!$(e.target).is('.header-menubar, .header-menubar *, .header-right-list, .header-right-list *')) {
        if($('.header-wrap').hasClass('menu-open')){
          $('.menu-bar .close-icon').click();
        }
      }
    });
  
  
    $('.page-container, .header-wrap, .smartwishlist').on('click.drawer', function(e){
      if($('#CartDrawer').hasClass('js-drawer-open')){
        $('#CartDrawer .js-drawer-close').click();
      }
    });
  
    $('.blog-carousel').slick({
      slidesToShow: 4,
      slidesToScroll: 2,
      infinite: true,
      dots: false,
      arrows: true,
      autoplay: false,
      responsive: [{
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
                   {
                     breakpoint: 768,
                     settings: {
                       slidesToShow: 1,
                       slidesToScroll: 1
                     }
                   }
                  ]
    });
  
  
    // $(document).ready(function () {
  
    //   $(".has-submenu").mouseenter(function(){
    //     $(".menu-dropdown").show(); 
    //   });
  
    //   $(".has-submenu").mouseleave(function(){
    //     $(".menu-dropdown").hide(); 
    //   });
    // });
  
    jQuery(window).load(function(){
      jQuery('a[href*="youtube.com/watch"]').magnificPopup({
        type: 'iframe',
        iframe: {
          patterns: {
            youtube: {
              index: 'youtube.com', 
              id: 'v=', 
              src: '//www.youtube.com/embed/%id%?rel=0'
            }
          }
        }   
      });      
    });
  
    $('body').on('click','.aside_slct_wrap',function(){
      // e.stopPropagation();
      if($(this).hasClass('active-ul')){
        $('body').removeClass("stop-scrolling");
      }else{
        $('body').addClass("stop-scrolling");
      }
    });
    function setCookie(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + (exdays*24*60*60*1000));
      var expires = "expires="+d.toUTCString();
      document.cookie = cname + "=" + cvalue + "; " + expires;
    }
    function getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
      }
      return "";
    }
  function delete_cookie(name) {
      document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
  
    $('body').on('click','.wall-header__filters-btn',function(){
      // e.stopPropagation();
      $(this).toggleClass('hidetxt');
      $(this).find('.wall-header__filter_text').text("Show Filters");
      $(this).find('.icon-filters').toggleClass("is--toggled");
      $('#collection-container').toggleClass('lhn--closed');
      equalheight('.gridview-item .title-flex a.pro-title');
      delete_cookie('clicklink');
      setCookie('clicklink', 'hidefilter');
  
    });
    $('body').on('click','.wall-header__filters-btn.hidetxt',function(){
      // e.stopPropagation();
      $(this).removeClass('hidetxt');
      //$(this).addClass('showtxt');
      $(this).find('.wall-header__filter_text').text("Hide Filters");
      // $(this).find('.icon-filters').toggleClass("is--toggled");
      delete_cookie('clicklink');
      setCookie('clicklink', 'showfilter');
  
    });
    checkCookieOnLoad();
    function checkCookieOnLoad() {
      var user=getCookie("clicklink");
      console.log('hi'+user);
      if(user == "hidefilter") {
        // Hide content and show clicklink
        $('#collection-container').removeClass('lhn--closed');
        $('.wall-header__filter_text').text("Show Filters");
        $('.wall-header__filters-btn').addClass("hidetxt");
         delete_cookie('clicklink');
       setCookie('clicklink', 'hidefilter');
      }else{
       // Show content and hide clicklink
        $('#collection-container').addClass('lhn--closed');
        $('.wall-header__filter_text').text("Hide Filters");
        $('.wall-header__filters-btn').removeClass("hidetxt");
         delete_cookie('clicklink');
        setCookie('clicklink', 'showfilter');
      }
    }  
  
  
    // $('body').on('click',function(){
    //  if($('.aside_slct_wrap').hasClass('active-ul')){
    //  $('body').removeClass("stop-scrolling");
    //  }else{
    //   $('body').addClass("stop-scrolling");
    // }
    // });
  
    // annoucement bars
    if($('#multi_announcement_bar').length > 0){
      $('#multi_announcement_bar').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        responsive: [{
          breakpoint: 1025,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
                     {
                       breakpoint: 768,
                       settings: {
                         slidesToShow: 1,
                         slidesToScroll: 1
                       }
                     }
                    ]
      });
    }
    //   if($("#products-faceted-search").length){
    //    if ($(window).width() >= 1024) {
    //     var offset = $("#products-faceted-search").offset();
    //   //	var footer_top = $(".page-footer").offset().top;
    //     var $el = $('.page-footer');  //record the elem so you don't crawl the DOM everytime  
  
    //     var topPadding = 218;
    //     $(window).scroll(function(){
    //        var bottom = $('.product-list-col').height() - 300;
    //    	  console.log("scrolltop="+$(window).scrollTop());	
    //       console.log("offsettop="+offset.top);	
    //       console.log("footeroffset="+bottom);	
    //       if ($(window).scrollTop() + 218 > offset.top) {
    //         if($(window).scrollTop() > bottom){
    //           $("#products-faceted-search").stop().animate({
    //                 marginTop: 0
    //             });
    //           $("#products-faceted-search").css("padding-top","0px");
  
    //         }else{
    //         	$("#products-faceted-search").css("padding-top","102px");
    //             $("#products-faceted-search").stop().animate({
    //                 marginTop: $(window).scrollTop() - offset.top + topPadding
    //             });
    //         }
    //       } else {
    //             $("#products-faceted-search").stop().animate({
    //                 marginTop: 0
    //             });
    //           $("#products-faceted-search").css("padding-top","0px");
    //         }
    //     });
    //    }
    //   }
  });  

document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;
  const drawer = document.querySelector(".drawer"); // Replace with actual drawer selector
  const closeButton = document.querySelector(".js-drawer-close"); // Close button

  document.addEventListener("click", function (event) {
    // Check if the drawer is open
    if (body.classList.contains("js-drawer-open")) {
      // Check if click is outside the drawer and not on allowed elements
      if (
        drawer && 
        !drawer.contains(event.target) && 
        !event.target.closest(".drawer") && 
        !event.target.closest(".ajaxcart__qty-adjust") && 
        !event.target.closest(".remove-cart-item") 
      ) {
        closeButton.click();
      }
    }
  });
});


